import { SegmentsStream } from '@mi-front/ui';
import { Box } from '@mui/material';

import { toTimestampRange } from '@app/helpers/range';
import { STREAM_HEIGHT, STREAM_HEIGHT_COMPACT } from '@app/modules/logger/screens/status/constants';
import { Segment, TimeRange } from '@mi-front/core';
import { useStatusViewContext } from '../../../context/StatusViewContext';
import { useEffectiveItemWidth } from '../../../hooks/useEffectiveItemWidth';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
  readonly segments: readonly Segment[];
  readonly range: TimeRange;
}

/**
 * Audio status preview component that displays segments data in a visual stream format.
 * Shows the full-width waveform for audio stations.
 */
export function AudioStatusPreview(p: Props) {
  const { station, segments, range } = p;
  const { compact } = useStatusViewContext();
  const effectiveWidth = useEffectiveItemWidth();
  const height = compact ? STREAM_HEIGHT_COMPACT : STREAM_HEIGHT;

  return (
    <Box sx={{ width: '100%' }}>
      <SegmentsStream
        tz={station.timezone}
        height={height}
        width={effectiveWidth}
        range={toTimestampRange(range)}
        segments={segments}
        fadeSides="left"
        hideSeconds={compact}
      />
    </Box>
  );
}
